import React from "react";

const Contact: React.FC = () => {
    const contacts = [
        {
            name: "Telegram",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" />
                </svg>
            ),
            url: "https://t.me/tdymcdonald",
            color: "from-blue-500 to-blue-600",
        },
        {
            name: "Snapchat",
            icon: (
                <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C7 2 4 5.5 4 9.5c0 1.5.4 2.9 1.1 4.1L4 18l2.5-.8c1.1.6 2.3 1 3.7 1.1.2.6.8 1 1.4 1h.8c.6 0 1.2-.4 1.4-1 1.4-.1 2.6-.5 3.7-1.1l2.5.8-1.1-4.4c.7-1.2 1.1-2.6 1.1-4.1C20 5.5 17 2 12 2z"/>
                </svg>
            ),
            url: "https://www.snapchat.com/@tdymcdonald?invite_id=M5CzP2HM&locale=fr_CA%40rg%3Dfrzzzz&share_id=G25Apgm5S86uihWB6vNlwA&sid=a5e5c953747a4289a5a3a399a0d91350&locale=fr-FR",
            color: "from-yellow-400 to-yellow-500",
        },
        {
            name: "Signal",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2.546 20.2a1 1 0 001.254 1.254l3.032-.892A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 01-4.243-1.212l-.3-.182-3.104.913.913-3.104-.182-.3A8 8 0 1112 20z" />
                    <path d="M12 6a6 6 0 100 12 6 6 0 000-12zm0 10a4 4 0 110-8 4 4 0 010 8z" />
                </svg>
            ),
            url: "https://signal.me/#eu/PeCUX_PHCKXzdCgqQCVgngjPGLnGCcTvYPtU8t7kt4QS9lOMLfNLErjKBVeko47y",
            color: "from-blue-600 to-blue-700",
        },
    ];

    return (
        <div className="min-h-screen py-20 px-4 relative">
            {/* Background image */}
            <div className="fixed inset-0 overflow-hidden">
                <div style={{
                    position: "absolute", top: "50%", left: "50%",
                    transform: "translate(-50%, -50%) rotate(90deg)",
                    width: "100vh", height: "100vw",
                    backgroundImage: "url('/bg.png')",
                    backgroundSize: "cover", backgroundPosition: "center",
                }}></div>
            </div>
            {/* Background overlay with opacity */}
            <div className="fixed inset-0 bg-primary-dark/85"></div>

            <div className="max-w-4xl mx-auto relative z-10">
                {/* Header */}
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                        Contactez-nous
                    </h1>
                    <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                        Choisissez votre methode de communication preferee. Nous
                        sommes disponibles 24/7.
                    </p>
                </div>

                {/* Contact Buttons */}
                <div className="flex flex-col items-center space-y-6">
                    {contacts.map((contact) => (
                        <a
                            key={contact.name}
                            href={contact.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`w-full max-w-md card p-6 flex items-center justify-center space-x-4
                bg-gradient-to-r ${contact.color} hover:scale-105 transition-all duration-300
                border-none shadow-lg hover:shadow-xl`}
                        >
                            <span className="text-white">{contact.icon}</span>
                            <span className="text-white text-xl font-semibold">
                                {contact.name}
                            </span>
                        </a>
                    ))}
                </div>

                {/* Info Section */}
                <div className="mt-16 text-center">
                    <div className="card p-8 max-w-2xl mx-auto">
                        <h2 className="text-2xl font-semibold text-white mb-4">
                            Informations
                        </h2>
                        <ul className="text-gray-300 space-y-3 text-left">
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>Reponse garantie sous 24h maximum</span>
                            </li>
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>
                                    Communication chiffree de bout en bout
                                </span>
                            </li>
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>Discretion absolue assuree</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
